import React, { useState, useEffect } from 'react';

import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

// Imagens do diretório public são servidas na raiz
const hero1 = '/assets/hero/image01.png';
const hero1Mobile = '/assets/hero/image01-mobile.png';


const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const heroSlides = [
    {
      id: 1,
      title: "Móveis Únicos, Feitos Especialmente para Você",
      subtitle: "Tradição Artesanal, Design Contemporâneo",
      description: "Cada peça é uma obra de arte criada por mestres artesãos brasileiros, utilizando madeiras nobres e técnicas tradicionais passadas de geração em geração.",
      image: hero1,
      category: "Sala de Estar",
      cta: "Explorar Catálogo",
      link: "/interactive-catalog"
    }
  ];

  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides?.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, heroSlides?.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  return (
    <section className="relative h-screen overflow-hidden bg-background">
      {/* Hero Slides */}
      <div className="relative h-full">
        {heroSlides?.map((slide, index) => (
          <div
            key={slide?.id}
            className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
              index === currentSlide 
                ? 'opacity-100 scale-100' :'opacity-0 scale-105'
            }`}
          >
            {/* Background Image */}
            <div className="absolute inset-0">
              {/* Desktop Image */}
              <Image
                src={slide?.image}
                alt={slide?.title}
                className="hidden md:block w-full h-full object-cover"
              />
              {/* Mobile Image */}
              <Image
                src={hero1Mobile}
                alt={slide?.title}
                className="block md:hidden w-full h-full object-cover"
              />
            </div>

          </div>
        ))}
      </div>
      {/* Navigation Controls */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex items-center space-x-6">
        {/* Slide Indicators */}
        <div className="flex space-x-3">
          {heroSlides?.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentSlide 
                  ? 'bg-primary scale-125' :'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 right-8 flex flex-col items-center space-y-2 text-white/70">
        <span className="text-sm font-medium">Rolar</span>
        <div className="w-px h-12 bg-white/30 relative">
          <div className="absolute top-0 w-px h-6 bg-primary animate-pulse"></div>
        </div>
        <Icon name="ChevronDown" size={20} />
      </div>
    </section>
  );
};

export default HeroSection;